import type { AntePostEventsTemplateView } from '@ps/web-sports-api-types';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { MarketTemplate } from '@swf/sports/components';
import SportsFormattedTimeZone from '@swf/sports/components/SportsFormattedTimeZone/SportsFormattedTimeZone';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';
import type { MarketLevelTemplateId } from '@swf/sports/types/templates';

import styles from './DatePanel.scss';

interface Props {
  dateGroup: AntePostEventsTemplateView[];
}

const DatePanel: React.FC<Props> = ({ dateGroup }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();
  const firstTemplateInPanel = dateGroup[0].template;

  const market = useSelector((state: RootState) =>
    widgetSelect.market(state, firstTemplateInPanel.marketId)
  );

  if (!market) return null;

  return (
    <div className={styles.dateWrapper}>
      <span className={styles.dateContainer}>
        <SportsFormattedTimeZone date={market.marketTime} format="medium" />
      </span>
      {dateGroup.map(({ template }) => (
        <MarketTemplate
          key={template.marketId}
          {...template}
          templateId={template.templateId as MarketLevelTemplateId}
        />
      ))}
    </div>
  );
};

export default DatePanel;
